var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompare = function SvgCompare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m8.94 9.539-1.06 1.039L3.5 6.289 7.88 2l1.06 1.039-2.556 2.503H15.5v1.469H6.359L8.94 9.539Zm2.62 7.538 1.06 1.04 4.38-4.29-4.38-4.288-1.06 1.038 2.556 2.504H5v1.469h9.141l-2.581 2.527Z"
  })));
};
export default SvgCompare;